export default "__VITE_ASSET__C2nJNvLC__"